import api from 'Application/api/api';

const getLocations = signal =>
	api.get('/projects/coordinates', {
		signal,
	});

export default getLocations;
